(function() { window.GUID_1b5b8bc2_2279_42e7_a41f_14c4b8287f0a = { getGuid: function() { return "1b5b8bc2-2279-42e7-a41f-14c4b8287f0a"; } }; })();
var TeamPlayerList;
(function (TeamPlayerList) {
    var treeViewDivisions;
    BindElements();
    function BindElements() {
        var cards = $('#Cards');
        //var entityPopup = $('#EntityPopup');
        //var lastTimer = null;
        cards.on('click', function (e) {
            var element = $(e.target);
            if (element.hasClass('SeeMore')) {
                var remain = $('.Players.Remain', element.closest('.TeamDetails'));
                if (remain.is(':visible')) {
                    remain.hide();
                }
                else {
                    remain.show();
                }
            }
        });
        CS.doc.tooltip.OverrideContent = function (callback) {
            var data = { entityBaseId: $(this).data('id') };
            CompuSport.Ajax.Get(CSParameters.RUrl + "TeamPlayerList/GetEntityPopup/" + CSParameters.SportEventId, data, function (queryResult) {
                callback.call(this, queryResult);
            });
        };
        CS.on('TreeViewIsLoaded', '#TreeViewDivisions', function (e, treeView) {
            treeViewDivisions = treeView;
            treeViewDivisions.TreeViewItemSelected = function (treeViewItem) {
                UpdateCards(treeViewItem);
            };
            if (treeViewDivisions.lastSelectedItem != null && treeViewDivisions.lastSelectedItem.length > 0) {
                UpdateCards(treeViewDivisions.lastSelectedItem);
            }
        });
        function UpdateCards(selectedTreeViewItem) {
            if (selectedTreeViewItem.data('values') == null) {
                return;
            }
            var data = {
                flowBlockId: selectedTreeViewItem.data('values')[0],
                divisionId: parseInt(selectedTreeViewItem.data('values')[1], 10),
                entityType: selectedTreeViewItem.data('values')[2],
                floatingSpareOnly: $('#FloatingSpareOnly').val().toLowerCase()
            };
            CompuSport.Ajax.Get(CSParameters.RUrl + "TeamPlayerList/RefreshTeamCards/" + CSParameters.SportEventId, data, function (response) {
                cards[0].innerHTML = response;
            });
        }
    }
    TeamPlayerList.BindElements = BindElements;
})(TeamPlayerList || (TeamPlayerList = {}));

//# sourceMappingURL=TeamPlayerList.js.map
